import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const ServicesFetureSectionForHome = () => {


  const [items, setItems] = useState([]);
  const [service, setService] = useState([]);


  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/featureitems`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/featurestext`)
      .then((res) => res.json())
      .then((info) => setService(info));
  }, []);


  return (


    <>
      <div>
        {
          service.map(e => e.pageSlug === '' && <section className="basic-feature feature-basicfeature">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="feature_wrapperleft">
                    <figure className="mb-0 feature-circle">
                      <img className="img-fluid" src="./assets/images/feature-circle.png" alt />
                    </figure>
                    <figure className="mb-0 featurephoneback">
                      <img src="./assets/images/featurephoneback-img.png" alt />
                    </figure>
                    <figure className="mb-0 featurephone">
                      <img className="img-fluid" src={e.FeaturesImg} alt />
                    </figure>
                    <figure className="mb-0 featurephone-over">

                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="feature_wrapperright">
                    <div className="feature_content">
                      <h4 className='heading-color'>{e.FeaturesText}</h4>
                      <h2>{e.FeaturesHeading}</h2>
                    </div>
                    <div className="feature_lowercontent" data-aos="fade-up">
                      <div className="row">
                        {
                          items.map(b => b.pageSlug === '' && <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="feature-design">
                              <div className="feature-box">
                                <figure className="feature-graphicon feature-box-2">
                                  <img src={b.FeaturesIcon} alt className="img-fluid" />
                                </figure>
                                <h6>{b.FeaturesText}</h6>
                                <p className="text-size-18 mb-0">{b.FeaturesDesc}</p>
                              </div>
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>)}
      </div>
    </>

  );
};

export default ServicesFetureSectionForHome;
